export class AttAttrezzatura {
    attId: number;
    attAttrezzatura: string;
    attCostoOrario: number;
    attDiaria: number;
    attOre?: any;
    attNumero?: any;
    attLitri?: any;
    attTipoAttrezzatura?: number;
}